var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ControlOption',{attrs:{"campos":_vm.campos,"camposIndex":_vm.camposIndex}},[_c('p',{staticClass:"my-1"},[_vm._v("Pregunta: "+_vm._s(_vm.campos.pregunta + (_vm.campos.obligatorio== 1 ? ' **' : '')))]),_c('v-text-field',{attrs:{"placeholder":"YYYY-MM-DD","disabled":"","solo":"","append-outer-icon":"far fa-calendar-alt"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }